// import {
//   Accordion,
//   AccordionItem,
//   AccordionItemHeading,
//   AccordionItemPanel,
//   AccordionItemButton,
// } from 'react-accessible-accordion';

// const Faq = (props) => {
//   const { itemClass } = props;
//   return (
//     <div className={itemClass ? itemClass : 'it-custom-accordion'}>
//       <Accordion className="accordion" preExpanded={'a'}>
//         <AccordionItem className="accordion-items" uuid="a">
//           <AccordionItemHeading>
//             <AccordionItemButton className="accordion-buttons">
//               <span>
//                 <i className="fal fa-check"></i>
//               </span>{' '}
//               How does the 30-day work?
//             </AccordionItemButton>
//           </AccordionItemHeading>
//           <AccordionItemPanel className="accordion-body">
//             <p>
//               Business tailored it design help ambitious businesses like yours
//               generate more building driving web traffice management & support
//               services profits to be business agency elit, sed do eiusmod
//               tempor.
//             </p>
//           </AccordionItemPanel>
//         </AccordionItem>
//         <AccordionItem className="accordion-items" uuid="b">
//           <AccordionItemHeading>
//             <AccordionItemButton className="accordion-buttons">
//               <span>
//                 <i className="fal fa-check"></i>
//               </span>{' '}
//               Maecenas facilisis erat id odio
//             </AccordionItemButton>
//           </AccordionItemHeading>
//           <AccordionItemPanel className="accordion-body">
//             <p>
//               Business tailored it design help ambitious businesses like yours
//               generate more building driving web traffice management & support
//               services profits to be business agency elit, sed do eiusmod
//               tempor.
//             </p>
//           </AccordionItemPanel>
//         </AccordionItem>
//         <AccordionItem className="accordion-items" uuid="c">
//           <AccordionItemHeading>
//             <AccordionItemButton className="accordion-buttons">
//               <span>
//                 <i className="fal fa-check"></i>
//               </span>{' '}
//               What happens trial?
//             </AccordionItemButton>
//           </AccordionItemHeading>
//           <AccordionItemPanel className="accordion-body">
//             <p>
//               Business tailored it design help ambitious businesses like yours
//               generate more building driving web traffice management & support
//               services profits to be business agency elit, sed do eiusmod
//               tempor.
//             </p>
//           </AccordionItemPanel>
//         </AccordionItem>
//         <AccordionItem className="accordion-items" uuid="d">
//           <AccordionItemHeading>
//             <AccordionItemButton className="accordion-buttons">
//               <span>
//                 <i className="fal fa-check"></i>
//               </span>{' '}
//               Maecenas facilisis erat id odio
//             </AccordionItemButton>
//           </AccordionItemHeading>
//           <AccordionItemPanel className="accordion-body">
//             <p>
//               Business tailored it design help ambitious businesses like yours
//               generate more building driving web traffice management & support
//               services profits to be business agency elit, sed do eiusmod
//               tempor.
//             </p>
//           </AccordionItemPanel>
//         </AccordionItem>
//       </Accordion>
//     </div>
//   );
// };

// export default Faq;
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';

const Faq = (props) => {
  const { itemClass } = props;
  return (
    <div className={itemClass ? itemClass : 'it-custom-accordion'}>
      <Accordion className="accordion" preExpanded={'a'}>
        
        <AccordionItem className="accordion-items" uuid="a">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              What services does your company provide?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              We specialize in a range of IT solutions including ERP & CRM development, 
              production and inventory management software, asset tracking, custom software 
              development, cloud solutions, mobile app development, and IT consulting. Our goal 
              is to help businesses optimize their operations with cutting-edge technology.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="accordion-items" uuid="b">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              How long does it take to implement your software solutions?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              The implementation time depends on the complexity of the solution. Standard software 
              installations can take a few weeks, while customized solutions like ERP or CRM 
              integrations may take a few months. Our team works closely with clients to ensure 
              a smooth and efficient deployment process.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="accordion-items" uuid="c">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              Do you offer ongoing support and maintenance?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Yes, we provide comprehensive support and maintenance services. Our support packages 
              include regular updates, security patches, and troubleshooting assistance. We also 
              offer 24/7 support for critical issues to ensure your business runs smoothly at all times.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="accordion-items" uuid="d">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              How secure are your software solutions?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Security is our top priority. Our software solutions are built with advanced encryption, 
              secure authentication methods, and compliance with industry security standards. We conduct 
              regular security audits to protect your data from potential cyber threats.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="accordion-items" uuid="e">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              Can your solutions be customized to fit our business needs?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Absolutely! We understand that every business has unique needs. Our team works 
              closely with clients to customize software solutions, ensuring they align perfectly 
              with your operational requirements and long-term business goals.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="accordion-items" uuid="f">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              What are your pricing models?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Our pricing varies based on the service, level of customization, and support 
              requirements. We offer flexible pricing models including one-time licensing, 
              subscription-based plans, and pay-as-you-go models. Contact us for a customized 
              quote tailored to your business needs.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="accordion-items" uuid="g">
          <AccordionItemHeading>
            <AccordionItemButton className="accordion-buttons">
              <span>
                <i className="fal fa-check"></i>
              </span>{' '}
              How do I get started with your services?
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="accordion-body">
            <p>
              Getting started is easy! Simply reach out to us through our contact form, email, or 
              phone. Our team will schedule a consultation to understand your business needs and 
              recommend the best solutions for your growth and efficiency.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

      </Accordion>
    </div>
  );
};

export default Faq;
